<div class="container-fluid" *ngIf="!summaryMode">
            <!-- Multiple Choice Mode (Checkboxes) -->
             <div *ngIf="isMultipleChoice">
            <div  class="form-check justify-content-start"
                 *ngFor="let option of options">                
                 @if (name === 'PT2_TOBACCO_1' && option === "I haven't used any nicotine products in the past 5 years.") 
                 {
                    <mat-checkbox 
                           name="answer_{{name}}_{{option}}"
                           [(ngModel)]="checkboxValue[option]"
                           (change)="onClick(option)"
                           id="answer_{{name}}_{{option}}"
                           [disabled]="noneOfTheAboveDisabled">
                           {{option}}</mat-checkbox>

                 }
                 @else if (name === 'PT2_ALCOHOL_1' && option === "I don't drink alcohol") 
                 {
                    <mat-checkbox 
                           name="answer_{{name}}_{{option}}"
                           [(ngModel)]="checkboxValue[option]"
                           (change)="onClick(option)"
                           id="answer_{{name}}_{{option}}"
                           [disabled]="noneOfTheAboveDisabled">
                           {{option}}</mat-checkbox>

                 }
                 @else
                 {
                    <mat-checkbox 
                           name="answer_{{name}}_{{option}}"
                           [(ngModel)]="checkboxValue[option]"
                           (change)="onClick(option)"
                           id="answer_{{name}}_{{option}}"
                           [disabled]="(showCustomNoneOfTheAbove || showNoneOfTheAbove) && noneOfTheAbove">
                    {{option}}</mat-checkbox>
                 }
            </div>
            </div>
            <!-- Single Choice Mode (Radio Buttons) -->
            <mat-radio-group *ngIf="!isMultipleChoice" 
                           [name]="'answer_' + name"
                           [(ngModel)]="value"
                           (change)="onClick($event.value)">
                <div class="form-check justify-content-start"
                     *ngFor="let option of options">
                    <mat-radio-button 
                           [value]="option"
                           id="answer_{{name}}_{{option}}">
                        {{option}}
                    </mat-radio-button>
                </div>
            </mat-radio-group>
            <div class="form-check justify-content-start" *ngIf="showNoneOfTheAbove">
                
                    <mat-checkbox 
                           name="answer_{{name}}_none_of_the_above"
                           [checked]="noneOfTheAbove"
                           (change)="onNoneClick($event.checked)"
                           id="answer_{{name}}_none_of_the_above"
                           [disabled]="noneOfTheAboveDisabled">
                           None of these apply to me</mat-checkbox>
            </div>

    <mat-error *ngIf="question.invalid">required</mat-error>
</div>
<div class="container-fluid" *ngIf="summaryMode">
    <div class="row">
        <div class="col-12">
            <div class="form-check justify-content-start"
                 *ngFor="let option of options">
                <label class="form-check-label" for="answer_{{name}}_{{option}}">
                    <input type="checkbox" class="form-check-input"
                           name="answer_{{name}}_{{option}}"
                           [(ngModel)]="checkboxValue[option]"
                           disabled="noneOfTheAbove || summaryMode">
                    {{option}}
                </label>
            </div>
            <div class="form-check justify-content-start" *ngIf="showNoneOfTheAbove">
                <label class="form-check-label" for="answer_{{name}}_none_of_the_above">
                    <input type="checkbox" class="form-check-input"
                           name="answer_{{name}}_none_of_the_above"
                           [(ngModel)]="noneOfTheAbove"
                           disabled="(value != null && value.length > 0) || summaryMode">
                    None of these apply to me
                </label>
            </div>
        </div>
    </div>
</div>
